import { Helmet } from "react-helmet-async";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { MarketingNav } from "@/components/marketing/MarketingNav";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";
import { Button } from "@/components/ui/button";

const About = () => (
  <>
    <Helmet>
      <title>About | EchoCRM</title>
      <meta name="description" content="EchoCRM is built for sales reps who live on their phones, between calls, sites, and meetings." />
      <link rel="canonical" href="https://echocrm.app/about" />
    </Helmet>

    <main className="min-h-screen bg-background text-foreground">
      <MarketingNav />

      <section className="theme-glow">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 pt-16 sm:pt-24 pb-12 sm:pb-16">
          <p className="text-[12px] font-mono-accent uppercase tracking-[0.18em] text-muted-foreground mb-4">About</p>
          <h1 className="font-display font-semibold text-[36px] sm:text-[56px] tracking-[-0.035em] leading-[1.05]">
            Built for the rep, not the manager.
          </h1>
          <p className="mt-6 text-[16px] sm:text-[18px] text-muted-foreground leading-[1.55]">
            Most CRMs are reporting tools dressed as workflow tools. EchoCRM started the other way around, by watching how
            high-volume reps actually work between calls, sites, and meetings, and removing every keystroke we could.
          </p>
        </div>
      </section>

      <section className="hairline-t">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-24 space-y-10">
          {[
            { h: "Speed over features", p: "Adding a lead should take seconds, not a long form. Voice notes, Telegram messages, and pasted transcripts all become structured records." },
            { h: "Mobile-first, honestly", p: "EchoCRM is designed at 375px first. The phone in your pocket is the primary device, not an afterthought." },
            { h: "Quiet by default", p: "No celebratory confetti, no AI sparkle. The interface stays out of the way so the work shows through." },
          ].map((b) => (
            <div key={b.h}>
              <h2 className="font-display font-semibold text-[20px] sm:text-[24px] tracking-[-0.02em] mb-2">{b.h}</h2>
              <p className="text-[15px] text-muted-foreground leading-[1.6]">{b.p}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="hairline-t">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-24">
          <h2 className="font-display font-semibold text-[24px] sm:text-[32px] tracking-[-0.02em] mb-6">Try it.</h2>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-5">
            <Button size="lg" className="w-full sm:w-auto" asChild>
              <Link to="/signup">Get started <ArrowRight className="h-4 w-4" /></Link>
            </Button>
            <Link to="/pricing" className="text-[14px] text-muted-foreground hover:text-foreground inline-flex items-center justify-center sm:justify-start gap-1.5 py-2">
              See pricing <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </main>
  </>
);

export default About;